import { getDataNavItems } from './data';
import { getDevelopNavItems } from './develop';
import { getInsightsNavItems } from './insights';
export { INSIGHTS_NAV_ITEMS, getInsightsNavItems } from './insights';
export { DATA_NAV_ITEMS, getDataNavItems } from './data';
export { DEVELOP_NAV_ITEMS, getDevelopNavItems } from './develop';
export const getAllSpotlightNavItems = (isPathEnabled, t) => {
    const tFn = t ?? ((key) => key);
    const all = [
        ...getInsightsNavItems(tFn),
        ...getDataNavItems(tFn),
        ...getDevelopNavItems(tFn),
    ];
    if (!isPathEnabled)
        return all;
    return all.filter(item => !item.path || isPathEnabled(item.path));
};
//# sourceMappingURL=index.js.map